var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 0.625H2.75C2.25272 0.625 1.77581 0.822544 1.42417 1.17417C1.07254 1.52581 0.875 2.00272 0.875 2.5V17.5C0.875 17.9973 1.07254 18.4742 1.42417 18.8258C1.77581 19.1775 2.25272 19.375 2.75 19.375H25.25C25.7473 19.375 26.2242 19.1775 26.5758 18.8258C26.9275 18.4742 27.125 17.9973 27.125 17.5V2.5C27.125 2.00272 26.9275 1.52581 26.5758 1.17417C26.2242 0.822544 25.7473 0.625 25.25 0.625ZM23.1875 2.5L14 8.85625L4.8125 2.5H23.1875ZM2.75 17.5V3.35312L13.4656 10.7687C13.6226 10.8776 13.809 10.936 14 10.936C14.191 10.936 14.3774 10.8776 14.5344 10.7687L25.25 3.35312V17.5H2.75Z",
    fill: "#DDDFDD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2042a8b1ade25f5b881fcf2036900e88.svg";
export { ForwardRef as ReactComponent };